import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { BiddingSectionCTAStateController } from '../BiddingSectionCTAStateController/BiddingSectionCTAStateController';
import { PurchaseModal } from '../PurchaseModal/PurchaseModal';

import { ProxyBidActions } from './ProxyBidActions/ProxyBidActions';

export const ProxyCTA: React.FC = () => {
	const { bidding, state } = useVehicleData();
	const { hasOtherContactActiveBid, latestUserBidOrOffer } = bidding;
	return (
		<BiddingSectionCTAStateController
			hasOtherContactActiveBid={hasOtherContactActiveBid}
			latestUserBidOrOffer={latestUserBidOrOffer}
			state={state}
		>
			<ProxyBidActions />
			<PurchaseModal />
		</BiddingSectionCTAStateController>
	);
};
